import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import IntegerInput from "commons/ui/input/IntegerInput";
import Select from "commons/ui/input/Select";
import Paper from "commons/ui/Paper";

import MetaFieldsForm from "components/subComponents/MetaFieldsForm";
import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";

import useCategoryForm from "hooks/form/useCategoryForm";

import { IndoorOrOutdoor } from "types/enums";

function CategoryForm({ categoryId }: { categoryId?: string }) {
    const { formHook } = useCategoryForm({ categoryId });

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridItem>
            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <Paper>
                        <GridColumn>
                            <GridRow>
                                <GridItem className={"title-margin"}>
                                    <h1>Categoria</h1>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-3"}>
                                    <Select
                                        label="Tipologia"
                                        options={[
                                            {
                                                value: IndoorOrOutdoor.indoor,
                                                label: "Indoor",
                                            },
                                            {
                                                value: IndoorOrOutdoor.outdoor,
                                                label: "Outdoor",
                                            },
                                        ]}
                                        value={form.type}
                                        setValue={setValue}
                                        path={"type"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-3"}>
                                    <IntegerInput
                                        label={"Ordinamento"}
                                        value={form.graphical_order}
                                        setValue={setValue}
                                        path={"graphical_order"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <GridRow className="title-margin">
                                <GridItem>
                                    <h2>Italiano</h2>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={"Nome"}
                                        startAdornment={TwoLanguagesAdornment("it")}
                                        value={form.text.it.name}
                                        setValue={setValue}
                                        path={"text.it.name"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={"Slug"}
                                        value={form.text.it.slug}
                                        startAdornment={TwoLanguagesAdornment("it")}
                                        setValue={setValue}
                                        path={"text.it.slug"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <GridRow className="title-margin">
                                <GridItem>
                                    <h2>Inglese</h2>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={"Nome"}
                                        value={form.text.en.name}
                                        startAdornment={TwoLanguagesAdornment("en")}
                                        setValue={setValue}
                                        path={"text.en.name"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={"Slug"}
                                        value={form.text.en.slug}
                                        startAdornment={TwoLanguagesAdornment("en")}
                                        setValue={setValue}
                                        path={"text.en.slug"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <MetaFieldsForm
                                text={form.text}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridColumn>
                    </Paper>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

export default CategoryForm;
